import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DynamicContainer } from '../../Layout/DynamicContainer';
import { default as Text, TextTypes } from '../../Text';

import StepNavigation from '../StepNavigation';
import GallerySlide from '../GallerySlide';
import NextSlideButton from '../NextSlideButton';

import CarouselNavigationButtons, { ButtonTypes } from '../CarouselNavigationButtons';

const GalleryContent = ({
    styles,
    rules,
    type,
    slides,
    activeIndex,
    moveToNextSlide,
    moveToNextSlideMobile,
    moveToSlideId,
    width,
    galleryType,
    withButtons,
}) => {
    const handleMobileNextSlide = React.useCallback(
        e => {
            e.stopPropagation();
            moveToNextSlideMobile();
        },
        [moveToNextSlideMobile],
    );

    return (
        <div className={styles.mainContainer}>
            <DynamicContainer extend={rules.extendStepNavContainer}>
                <DynamicContainer extend={rules.extendStepNavFluidContainer} isFluid>
                    <StepNavigation
                        type={type}
                        slides={slides}
                        currentSlide={activeIndex}
                        nextSlide={moveToNextSlide}
                        moveToSlideId={moveToSlideId}
                        withButtons={withButtons}
                    />
                    <Text extend={rules.extendText} type={TextTypes.LARGE}>
                        {slides[activeIndex].description && <FormattedMessage id={slides[activeIndex].description} />}
                    </Text>
                </DynamicContainer>
            </DynamicContainer>
            <div className={styles.container}>
                {slides.map((slide, index) => (
                    <GallerySlide
                        key={slide.id}
                        width={width}
                        slidesCount={slides.length}
                        moveToNextSlide={moveToNextSlide}
                        moveToNextSlideMobile={moveToNextSlideMobile}
                        isActive={activeIndex === index}
                        src={slide.src}
                        alt={slide.alt}
                        galleryType={galleryType}
                        withButtons={withButtons}
                    />
                ))}
            </div>

            {withButtons ? (
                <CarouselNavigationButtons
                    {...{
                        moveToSlideId,
                        activeIndex,
                        type: ButtonTypes.LIGHT,
                        extend: {
                            navigationContainer: rules.navigationContainer,
                            navigationButton: rules.navigationButton,
                        },
                    }}
                />
            ) : (
                <NextSlideButton extend={rules.extendButton} onClick={handleMobileNextSlide} />
            )}
        </div>
    );
};

GalleryContent.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
    rules: PropTypes.shape().isRequired,
    type: PropTypes.string.isRequired,
    slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    activeIndex: PropTypes.number.isRequired,
    moveToNextSlide: PropTypes.func.isRequired,
    moveToNextSlideMobile: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    galleryType: PropTypes.string.isRequired,
    moveToSlideId: PropTypes.func.isRequired,
    withButtons: PropTypes.bool.isRequired,
};

export default GalleryContent;
